import CertificateElement from "./certificateElement";
import {certificateElementType} from "~/enums/certificateElementType";
import TextElement from "./concerns/textElement";

export default class TextCertificateElement extends TextElement(CertificateElement) {
  type: certificateElementType.Text;


  get renderWidth(): number {
    return this.width;
  }

  get renderHeight(): number {
    return  this.height;
  }

}